// extracted by css-extract-rspack-plugin
export default {"button":"J6diA","icons":"zBuKB","icon":"KfulY","label":"xokjR"};